<div class="station-status" [ngClass]="{'dark-mode': darkMode===true}">
  <ng-container *ngIf="stationStatus">
    <div class="left">
      <div class="logo" [ngStyle]="{ 'background-image': 'url('+serverRoot +'/app-client/resource/by-usage/'+tenant+'/display-logo)' }"></div>
      <div class="station-name">
        <div class="label">{{gateLabel}}</div>
        <div class="value">{{stationStatus.stationIdentifier}}</div>
      </div>
    </div>
    <div class="right">

      <ng-container *ngIf="isLocked()">
        <div class="disablement-hint">
          <sc-icon iconClass="fa-times fa-3x"></sc-icon>
          <span class="hint">
            <div class="title">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.station-status.locked.hint"></sc-dictionary-label>
            </div>
          </span>
        </div>
      </ng-container>

        <ng-container *ngIf="isLocked()">
          <div class="disablement-hint">
            <sc-icon iconClass="fa-times fa-3x"></sc-icon>
            <span class="hint">
              <div class="title">
                <sc-dictionary-label dictionaryKey="tmc-yard.widgets.station-status.locked.hint"></sc-dictionary-label>
              </div>
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="hasStationDisablement()">
          <div class="disablement-hint">
            <sc-icon iconClass="fa-exclamation-triangle fa-3x"></sc-icon>
            <span class="hint">
              {{stationStatus.disablementNote}}
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="!hasStationDisablement() && !isLocked()">
          <div class="transport-data">
            <ng-container *ngFor="let attribute of visibleAttributes; let i = index;">
              <div class="value" [ngClass]="attribute" *ngIf="getLabelByAttribute(attribute)!=''">
                <span class="label">
                  {{getLabelByAttribute(attribute)}}
                </span>
                <span class="content" [ngClass]="getClassForAttribute(attribute)">
                  {{getValueByAttribute(attribute)}}
                </span>
              </div>
            </ng-container>
          </div>
        </ng-container>



        <div class="camera-view" *ngIf="cameraUrl != null">
          <img [src]="cameraUrl" width="100%"/>
        </div>


        <div class="camera-view" *ngIf="cameraUrl != null">
          <img [src]="cameraUrl" height="100%"/>
        </div>

    </div>
  </ng-container>
</div>
